var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIconWhite2 = function SvgShareIconWhite2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M5.625 6.875H3.75c-1.036 0-1.875.84-1.875 1.875v7.5c0 1.035.84 1.875 1.875 1.875h12.5c1.035 0 1.875-.84 1.875-1.875v-7.5c0-1.036-.84-1.875-1.875-1.875h-1.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.463 4.375 9.998.839l3.536 3.536M10 1.5v9.75"
  })));
};
export default SvgShareIconWhite2;